<template>
<div>
    <Breadcrumbs main="Admin" submain="Blog" title="Blog" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <router-link :to="{ name: 'blogCreate' }">
                            <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Write New Blog</h7>
                            </button>
                        </router-link>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="blog_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(thumbnail)="row">
                                        <div style="min-width: 120px;">
                                            <img v-if="row.item.thumbnail || row.item.banner" style="max-height: 70px; max-width: 120px; border-radius: 6px; object-fit: cover;" :src="host + (row.item.thumbnail || row.item.banner)" alt="">
                                        </div>
                                    </template>

                                    <template #cell(title)="row">
                                        <div style="min-width: 240px; max-width: 420px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7 style="font-weight: 600;">{{ row.item.title }}</h7>
                                            <small v-if="row.item.summary" class="text-muted">{{ truncateText(row.item.summary, 90) }}</small>
                                            <a :href="siteBlogUrl + row.item.slug" target="_blank" rel="noopener noreferrer" class="view-link">
                                                View on site
                                            </a>
                                        </div>
                                    </template>

                                    <template #cell(blocks)="row">
                                        <b-badge variant="light">{{ (row.item.content || []).length }} sections</b-badge>
                                    </template>

                                    <template #cell(is_published)="row">
                                        <div style="display: flex; flex-direction: column; gap: 4px; align-items: flex-start;">
                                            <b-badge :variant="row.item.is_published ? 'success' : 'secondary'" style="cursor: pointer;" v-b-tooltip.hover title="Click to toggle" @click="toggle('togglePublished', row.item.slug)">
                                                {{ row.item.is_published ? 'Published' : 'Draft' }}
                                            </b-badge>
                                            <b-badge :variant="row.item.is_featured ? 'warning' : 'light'" style="cursor: pointer;" v-b-tooltip.hover title="Click to toggle" @click="toggle('toggleFeatured', row.item.slug)">
                                                {{ row.item.is_featured ? 'Featured' : 'Not Featured' }}
                                            </b-badge>
                                        </div>
                                    </template>

                                    <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="min-width: 100px;">
                                            {{ row.item.created_on | moment("DD MMM YYYY") }}
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteBlog(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div>
                                                <router-link :to="{ name: 'blogEdit', params: { slug: data.item.slug } }">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                                </router-link>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Blog Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this blog?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            siteBlogUrl: 'https://createquickcv.com/blog-details/',
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'thumbnail',
                    label: 'Image'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'blocks',
                    label: 'Content'
                },
                {
                    key: 'is_published',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'created_on',
                    label: 'Created',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            blog_list: state => state.blog.blog,
            loading: state => state.blog.blogLoading,
            error: state => state.blog.blogError
        })
    },

    mounted() {
        this.$store.dispatch("blog/fetchBlog").then(() => {
            this.totalRows = this.blog_list?.length;
        });
    },

    methods: {
        truncateText(text, maxLength) {
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems?.length;
            this.currentPage = 1;
        },

        toggle(action, slug) {
            this.$store.dispatch(`blog/${action}`, slug).then(response => {
                Swal.fire({
                    title: response.code == 200 ? "Success!" : "Error!",
                    text: response.response,
                    icon: response.code == 200 ? "success" : "error"
                });
            })
        },

        deleteBlog(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("blog/deleteBlog", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.view-link {
    display: inline-block;
    width: fit-content;
    padding: 2px 14px;
    border-radius: 999px;
    background: #f0f4ff;
    color: #2563eb;
    text-decoration: underline;
    font-weight: 500;
    font-size: 13px;
}
</style>
